import React, { Component } from 'react';
// import { Link } from 'react-router-dom';
import AnchorLink from 'react-anchor-link-smooth-scroll';
import {Helmet} from "react-helmet";
import Footer from './footer';
import Hero from '../../assets/hero-2.svg';
import MobileHero from '../../assets/hero-mobile.svg';
// import Matt from '../../assets/matt-aidem.png';
// import Aaron from '../../assets/aaron.png';
import Nav from '../layout/navigation';
import Users from '../../assets/howler-users.svg';
import Media from '../../assets/media-outlets-prod.svg';
import Matt from '../../assets/matt-aidem.png';
import Aaron from '../../assets/aaron.png';
import Albert from '../../assets/albert.jpg';
import Rumblr from '../../assets/rumblr.png';
import Chad from '../../assets/chad.jpeg';
import Nile from '../../assets/nile.jpeg';
import Tim from '../../assets/optemization.jpg';
import Lukas from '../../assets/lukas.jpg';
import Will from '../../assets/will.jpeg';
import Jack from '../../assets/jack-darknet.jpg';

import {
  InstantSearch,
  Hits,
  SearchBox,
  Configure,
  Stats,
} from 'react-instantsearch-dom';
import searchClient from '../Dashboard/algoliaCred';
import TrialSearchResult from '../search/FreeHeavenSearchResult';
import TrialPodcastSearchResult from '../search/FreeHeavenPodcastResult';

class HomePage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      width: 0,
      height: 0,
      searchTerm: "",
      isJournalistActive: true,
      isPodcastActive: false,
    };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }
  componentDidMount() {
    window.scrollTo(0, 0);
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
    this.randomize();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }

  randomize() {
    var number = Math.floor((Math.random() * 6) + 1);
    switch(number) {
      case 1:
        this.setState({
          searchTerm: "techcrunch.com"
        });
        break;
      case 2:
        this.setState({
          searchTerm: "nytimes.com"
        });
        break;
      case 3:
        this.setState({
          searchTerm: "Fashion"
        });
        break;
      case 4:
        this.setState({
          searchTerm: "Technology"
        });
        break;
      case 5:
        this.setState({
          searchTerm: "Sports"
        });
        break;
      default:
        this.setState({
          searchTerm: "techcrunch.com"
        });
    }
  }

  toggleJournalistNav = () => {
    this.setState(prevState => ({
      isJournalistActive: !prevState.isJournalistActive,
      isPodcastActive: !prevState.isPodcastActive
    }))
  }
  togglePodcastNav = () => {
    this.setState(prevState => ({
      isPodcastActive: !prevState.isPodcastActive,
      isJournalistActive: !prevState.isJournalistActive
    }))
  }

  render() {
    return (
      <div>
        <Helmet>
          <title>Press Hunt is a journalist database of 580,000 journalists 🚀</title>
          <meta name="description" content="Press Hunt is a comprehensive journalist database complete with almost 580,000 journalist emails to feature your business 🚀" />

          <meta itemprop="name" content="Press Hunt is a journalist database of 580,000 journalist emails 🚀" />
          <meta itemprop="description" content="Press Hunt is a comprehensive journalist database complete with almost 580,000 journalist emails to feature your business 🚀" />
          <meta itemprop="image" content="https://i.imgur.com/uOpUy46.png" />

          <meta property="og:url" content="https://presshunt.co" />
          <meta property="og:type" content="website" />
          <meta property="og:title" content="Press Hunt is a journalist database of 580,000 journalist emails 🚀" />
          <meta property="og:description" content="Press Hunt is a comprehensive journalist database complete with almost 580,000 journalist emails to feature your business 🚀" />
          <meta property="og:image" content="https://i.imgur.com/uOpUy46.png" />

          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:title" content="Press Hunt is a journalist database of 580,000 journalist emails 🚀" />
          <meta name="twitter:description" content="Press Hunt is a comprehensive journalist database complete with almost 580,000 journalist emails to feature your business 🚀" />
          <meta name="twitter:image" content="https://i.imgur.com/uOpUy46.png" />

          <script type="text/javascript" src="https://load.fomo.com/api/v1/ksXVzd4vYzGtJY7N0vc1eQ/load.js" async></script>

        </Helmet>

        <Nav />

        { this.state.width > 900 ? <img
          src={ Hero }
          className="is-overlay"
          alt="desktop hero"
        /> : <img
          src={ MobileHero }
          className="is-overlay"
          alt="mobile hero"
        />}

        <section className="section has-bg-image is-centered has-text-centered" style={{ height: "28em" }}>
          <script type="text/javascript" src="https://load.fomo.com/api/v1/ksXVzd4vYzGtJY7N0vc1eQ/load.js" async></script>
          <div className="columns">
            <div className="column">
              <div className="container is-overlay has-padding-bottom">
                <div className="hero-div-width">
                  <h1 className="title has-text-white has-text-weight-bold is-hero-title-center is-size-3">
                    Get connected with the best journalists to feature your business in seconds
                  </h1>
                  <h2 className="subtitle has-text-white has-text-weight-normal is-hero-title-center is-size-4" style={{opacity:'.75'}}>
                    Press Hunt saves you hundreds of hours by aggregating data on over 750k journalists, reporters, and podcasts in one place, complete with their coverage focuses and contact info
                  </h2>
                   <br />
                </div>

                <a className="button is-stripe-hero-exclamation" href="/pricing">Discover journalists&nbsp;&nbsp;<i className="fas fa-arrow-right"></i></a>
                <AnchorLink href="#search" className={ this.state.isActive ? 'button is-hiw-hero' : 'button is-hiw-hero-exclamation'}>Try for free</AnchorLink>
                <p className="has-text-white is-size-6 is-hero-sub"></p>
              </div>
            </div>
          </div>
        </section>

        <section className="section">
          <div className="container">
            <div className="columns has-text-centered is-centered">
              <div className="column is-hiw-card">
                <div className="circle-icon is-size-2 has-padding-bottom">
                  <span role="img" aria-label="dart">🎯</span>
                </div>
                <div className="title is-size-4 para-title">
                  750,000+ journalists & podcasts to pitch your business to today
                </div>
              </div>
              <div className="column is-hiw-card">
                <div className="circle-icon is-size-2">
                  <span role="img" aria-label="magnifying glass">🔎</span>
                </div>
                <div className="title is-size-4 para-title">
                  Complete with emails, phone numbers, and millions more data points
                </div>
              </div>
              <div className="column is-hiw-card">
                <div className="circle-icon is-size-2">
                  <span role="img" aria-label="doc">🗃</span>
                </div>
                <div className="title is-size-4 para-title">
                  Create lists of your favorites and export their contacts to CSV
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="section is-paddingless mt-48">
          <img
            src={ Media }
            style={{width:'100%',zIndex:'0'}}
            alt="media logos"
          />
        </section>

        <section className="section has-background-white" id="search">
          <div className="container is-centered clear-section-card">
            <div className="pricing-head has-text-centered is-centered has-text-black">
              <h2 className="title has-text-centered is-centered" id="pricing">The most powerful journalist database on the internet</h2>
              <p className="subtitle has-text-centered is-centered pricing-sub">You can try using Press Hunt for free below. Premium data is redacted until you subscribe.</p>
            </div>
            <div className="has-text-centered">
              <div className="trial-search-wrapper">
                <div className="tabs">
                  <ul>
                    <li className={this.state.isJournalistActive ? "is-trial-search-tab-active" : "is-trial-search-tab-inactive"}>
                      <a onClick={this.toggleJournalistNav}>
                        <span>Journalists</span>
                      </a>
                    </li>
                    <li className={this.state.isPodcastActive ? "is-trial-search-tab-active" : "is-trial-search-tab-inactive"}>
                      <a onClick={this.togglePodcastNav}>
                        <span>Podcasts</span>
                      </a>
                    </li>
                  </ul>
                </div>
              <div className={this.state.isJournalistActive ? "trial-search-results-container is-centered" : "not-displayed"}>
                <InstantSearch
                  searchClient={searchClient}
                  indexName="journalists-test"
                >
                  <SearchBox
                    autofocus
                    translations={{ placeholder: "Try searching our database for free…" }}
                    defaultRefinement={this.state.searchTerm}
                    className="journalist-searchbox-input-width-landing"
                  />

                  <Configure hitsPerPage={3} />
                  <Hits hitComponent={TrialSearchResult} />
                  <Stats className="has-text-weight-semibold" />
                </InstantSearch>
              </div>
              <div className={this.state.isPodcastActive ? "trial-search-results-container is-centered" : "not-displayed"}>
                <InstantSearch
                  searchClient={searchClient}
                  indexName="podcasts"
                >
                  <SearchBox
                    autofocus
                    translations={{ placeholder: "Try searching our database for free…" }}
                    defaultRefinement={this.state.searchTerm}
                  />

                  <Configure hitsPerPage={3} />
                  <Hits hitComponent={TrialPodcastSearchResult} />
                  <Stats className="has-text-weight-semibold" />
                </InstantSearch>
              </div>
                <a className="button is-new-journalist-button-home" href="/journalists/new/?ref=home">Submit new journalist</a>
              </div>
            </div>
          </div>
        </section>

        <section className="section" id="howitworks">
          <div className="container clear-section-card-writing-samples">
            <div className="pricing-head has-text-centered is-centered has-text-black">
              <h2 className="title has-text-centered is-centered">How it works</h2>
              <p className="subtitle has-text-centered is-centered pricing-sub">Getting started with Press Hunt only takes a few seconds!</p>
            </div>
            <div className="columns">
              <div className="column is-hiw-card">
                <div className="circle-icon is-size-2">
                  <span role="img" aria-label="magnifying glass">🔎</span>
                </div>
                <div className="title is-size-4 para-title">
                  1. Find relevant journalists
                </div>
                <p className="subtitle is-size-5 is-hiw-para">
                  Search through our constantly evolving database of journalists categorized by what they’re most likely to write about next
                </p>

              </div>
              <div className="column is-hiw-card">
                <div className="circle-icon is-size-2">
                  <span role="img" aria-label="star">⭐️</span>
                </div>
                <div className="title is-size-4 para-title">
                  2. Save your favorite journalists to your own media lists
                </div>
                <p className="subtitle is-size-5 is-hiw-para">
                  Save the best journalists to your media lists so you can pitch them when you’re ready
                </p>
              </div>
              <div className="column is-hiw-card">
                <div className="circle-icon is-size-2">
                  <span role="img" aria-label="letter">💌</span>
                </div>
                <div className="title is-size-4 para-title">
                  3. Start pitching!
                </div>
                <p className="subtitle is-size-5 is-hiw-para">
                  Export your media lists to CSV, import the journalist contact info into your favorite email system, and start sending them your pitches
                </p>
              </div>
            </div>
          </div>
        </section>

        <section className="section">
          <div className="has-text-centered is-centered">
            <p className="is-size-6 has-text-weight-normal used-by">Our database has been used to run PR campaigns for companies like:</p>
            <img
              src={ Users }
              style={{width:'100%',zIndex:'0'}}
              alt="User logos"
            />
            <a href="https://www.producthunt.com/posts/press-hunt?utm_source=badge-featured&utm_medium=badge&utm_souce=badge-press-hunt" target="_blank" rel="noopener noreferrer">
              <img src={"https://api.producthunt.com/widgets/embed-image/v1/featured.svg?post_id=123406&theme=dark"} alt="Press Hunt - Find the best journalists to cover you with our DB of 500k 🎉 | Product Hunt Embed"  className="mx-auto" style={{width: "250px", height: "54px", marginTop:'2em'}} />
            </a>
            <a href="https://www.producthunt.com/posts/press-hunt-2-0?utm_source=badge-featured&utm_medium=badge&utm_souce=badge-press-hunt-2-0" target="_blank" rel="noopener noreferrer">
              <img src={"https://api.producthunt.com/widgets/embed-image/v1/featured.svg?post_id=141052&theme=dark"} className="mx-auto" style={{width: "250px", height: "54px", marginTop:'1em'}} />
            </a>
            <a href="https://www.producthunt.com/posts/pr-requests?utm_source=badge-top-post-badge&utm_medium=badge&utm_souce=badge-pr-requests" target="_blank" rel="noopener noreferrer">
              <img src={"https://api.producthunt.com/widgets/embed-image/v1/top-post-badge.svg?post_id=180815&theme=dark&period=daily"} className="mx-auto" style={{width: "250px", height: "54px", marginTop:'1em'}} />
            </a>
          </div>
        </section>

        <section className="section has-background-white">
          <div className="container has-text-centered is-centered clear-section-card">
            <div className="pricing-head has-text-centered is-centered has-text-black">
              <h2 className="title has-text-centered is-centered" id="pricing">What do you get with Press Hunt?</h2>
              <p className="subtitle has-text-centered is-centered pricing-sub">A journalist database of 550k+ journalists and a podcast database of 200k+ podcasts, complete with emails, phone numbers, and coverage catgeorization</p>
            </div>
            <div className="columns">
              <div className="column is-feature-col">
                <div className="has-text-centered">
                  <div className="is-size-2">
                    <span role="img" aria-label="dart">🎯</span>
                  </div>
                  <p className="title has-text-weight-bold is-size-4">580,000+ journalists at your fingertips</p>
                  <p className="subtitle is-size-6 is-feature-para">We match you with hundreds of journalists based on what they’ve written about before, what they've tweeted about, and where they write</p>
                </div>
              </div>
              <div className="column is-feature-col">
                <div className="has-text-centered">
                  <div className="is-size-2">
                    <span role="img" aria-label="globe">🌍</span>
                  </div>
                  <p className="title has-text-weight-bold is-size-4">Journalists and podcasts from all over the world</p>
                  <p className="subtitle is-size-6 is-feature-para">Our journalists, reporters, media outlets, and podcasts cover stories on every continent except Antarctica</p>
                </div>
              </div>
            </div>
            <div className="columns">

              <div className="column is-feature-col">
                <div className="has-text-centered">
                  <div className="is-size-2">
                    <span role="img" aria-label="radio">📻</span>
                  </div>
                  <p className="title has-text-weight-bold is-size-4">200,000+ podcasts to pitch your business to</p>
                  <p className="subtitle is-size-6 is-feature-para">Podcasts are the future of media––Press Hunt has aggregated over 200,000 complete with their emails, website, and social media links to help you pitch them on featuring your business or running your ads</p>
                </div>
              </div>
              <div className="column is-feature-col">
                <div className="has-text-centered">
                  <div className="is-size-2">
                    <span role="img" aria-label="magnifying glass">🔎</span>
                  </div>
                  <p className="title has-text-weight-bold is-size-4">Search through journalists & podcasts by what stories they like to cover, their industries, parent media outlets, and more</p>
                  <p className="subtitle is-size-6 is-feature-para">Search through journalist interests, industry focuses, their parent media outlets, social media accounts and more! Press Hunt has millions of data points on journalists and podcasts</p>
                </div>
              </div>
            </div>
            <div className="columns">
              <div className="column is-feature-col">
                <div className="has-text-centered">
                  <div className="is-size-2">
                    <span role="img" aria-label="article">📝</span>
                  </div>
                  <p className="title has-text-weight-bold is-size-4">Journalists & podcasts categorized by what they’re likely to cover next</p>
                  <p className="subtitle is-size-6 is-feature-para">Journalist and podcast tags are derived from data about where they work, what they’ve covered before, and what they've tweeted about so you can find the journalists and podcasts most likely to cover you</p>
                </div>
              </div>
              <div className="column is-feature-col">
                <div className="has-text-centered">
                  <div className="is-size-2">
                    <span role="img" aria-label="media lists">🗃</span>
                  </div>
                  <p className="title has-text-weight-bold is-size-4">Build lists of your favorite journalists & podcasts and export their contact info to CSV</p>
                  <p className="subtitle is-size-6 is-feature-para">With Press Hunt you can create media lists of up to 200 journalists and podcasts and export their emails to CSV so you can pitch them your story</p>
                </div>
              </div>
            </div>
            <div className="columns">
              <div className="column is-feature-col">
                <div className="has-text-centered">
                  <div className="is-size-2">
                    <span role="img" aria-label="crystal ball">🔮</span>
                  </div>
                  <p className="title has-text-weight-bold is-size-4">Our journalists & podcasts cover everything from startups and crypto to fashion, art, and photography</p>
                  <p className="subtitle is-size-6 is-feature-para">Our journalists & podcasts cover everything: sports, fashion, food, startups, rockets, flowers, SAAS, ICOs, kickstarter campaigns, photography, religion, and more!</p>
                </div>
              </div>
              <div className="column is-feature-col">
                <div className="has-text-centered">
                  <div className="is-size-2">
                    <span role="img" aria-label="star">🌟</span>
                  </div>
                  <p className="title has-text-weight-bold is-size-4">Every plan comes with both our journalist database & podcast database to maximize your outreach efforts</p>
                  <p className="subtitle is-size-6 is-feature-para">Podcasts are the media outlets of the future, and along with journalist and traditional media outreach, can maximize your chances of getting great media coverage</p>
                </div>
              </div>
            </div>
            <a className="button is-stripe-hero" href="/pricing">Subscribe now&nbsp;&nbsp;<i className="fas fa-arrow-right"></i></a>
          </div>
        </section>

        <section className="section">
          <div className="container clear-section-card">
            <div className="pricing-head has-text-centered is-centered has-text-black">
              <h2 className="title has-text-centered is-centered">Our users love us</h2>
              <p className="subtitle has-text-centered is-centered pricing-sub">Our database has been used by dozens of companies from all over the world</p>
            </div>
            <div className="columns">
            <div className="column is-hiw-card">
              <div className="subtitle is-size-5 has-text-weight-normal">
                "Thanks for your hard work. I did get this interview on the Mike Koolidge show, which I guess is going to be broadcast later today to thousands of people? This kind of persistence is NOT something I could do on my own. So thanks for your hard work on it. That's the first win! Yay! Also I have the BBC interview setup for Thursday. So we'll see what happens then!"
              </div>
              <div className="testimonial-profile-pic-wrapper">
                <img
                  src={ Jack }
                  className="is-testimonial-photo"
                  >
                </img>
                <p className="is-size-6 has-text-weight-semibold is-marginless is-testimonial-name">Jack Rhysider, Host of Darknet Diaries podcast</p>
              </div>
            </div>
              <div className="column is-hiw-card">
                <div className="subtitle is-size-5 has-text-weight-normal">
                  "I've launched a number of projects that I look for press and often the most time consuming part is finding and researching relevant journalists. I was extremely please with how easy Press Hunt is to use. I had a whole list of journalists that I wanted to contact but was unable to find accurate emails and Press Hunt did the job. I would highly recommend it."
                </div>
                <div className="testimonial-profile-pic-wrapper">
                  <img
                    src={ Lukas }
                    className="is-testimonial-photo"
                    >
                  </img>
                  <p className="is-size-6 has-text-weight-semibold is-marginless is-testimonial-name">Lukas Bentel, Founder of Hello Velocity</p>
                </div>
              </div>
              <div className="column is-hiw-card">
                <div className="subtitle is-size-5 has-text-weight-normal">
                  "Press Hunt has a seemingly endless database and tons of little details on each journalist - feels like clearbit for PR. Rounded off with a simple UI, this product is brilliant for anyone trying to get their name out there to relevant journalists."
                </div>
                <div className="testimonial-profile-pic-wrapper">
                  <img
                    src={ Nile }
                    className="is-testimonial-photo"
                    >
                  </img>
                  <p className="is-size-6 has-text-weight-semibold is-marginless is-testimonial-name"> Nile Frater, Founder of ConcreteCapital</p>
                </div>
              </div>
            </div>
            <div className="columns">
              <div className="column is-hiw-card">
                <div className="subtitle is-size-5 has-text-weight-normal">
                  "I've seen Matt and his team get millions of impressions and coverage for clients. I highly recommend their services."
                </div>
                <div className="testimonial-profile-pic-wrapper">
                  <img
                    src={ Chad }
                    className="is-testimonial-photo"
                    >
                  </img>
                  <p className="is-size-6 has-text-weight-semibold is-marginless is-testimonial-name">Chad Grills, Founder & CEO of The Mission</p>
                </div>
              </div>
              <div className="column is-hiw-card">
                <div className="subtitle is-size-5 has-text-weight-normal">
                  "They did an excellent job increasing traffic to our website. We saw a major lift in both SEO and ASO after working with them."
                </div>
                <div className="testimonial-profile-pic-wrapper">
                  <img
                    src={ Will }
                    className="is-testimonial-photo"
                    >
                  </img>
                  <p className="is-size-6 has-text-weight-semibold is-marginless is-testimonial-name">Will Jamieson, Founder of Yik Yak & The Q</p>
                </div>
              </div>
              <div className="column is-hiw-card">
                <div className="subtitle is-size-5 has-text-weight-normal">
                  "We’ve been using this to reach out to journalists about our hackathons and startup competition at NYU. Much better than researching reporters on Google and finding their emails manually."
                </div>
                <div className="testimonial-profile-pic-wrapper">
                  <img
                    src={ Tim }
                    className="is-testimonial-photo"
                    >
                  </img>
                  <p className="is-size-6 has-text-weight-semibold is-marginless is-testimonial-name">Tim Nugmanov, President of NYU Innovention Society</p>
                </div>
              </div>
              </div>
            <div className="is-centered has-text-centered" style={{marginTop:'2em'}}>
              <a className="button is-stripe-hero" href="/pricing">Subscribe now&nbsp;&nbsp;<i className="fas fa-arrow-right"></i></a>
            </div>

          </div>
        </section>

        <section className="section">
          <div className="container has-text-centered is-centered">
            <div className="pricing-head has-text-centered is-centered has-text-black">
              <h2 className="title has-text-centered is-centered">Our team</h2>
              <p className="subtitle has-text-centered is-centered pricing-sub">We're building the PR tools of the future in New York City & Southern California</p>
            </div>
            <div className="columns">
              <div className="column">
                <img
                  src= {Matt}
                  className="h-20 w-20 m-auto"
                />
                <p className="has-text-weight-bold is-size-4 person-title">Matt Henderson</p>
                <p className="is-size-6">
                  <b>Co-founder</b> • Growth marketer & PR consultant whose work has been featured by over 200 global media outlets from from The Washington Post to Bleacher Report to Conan O'Brien<br /><br />
                </p>
              </div>
              <div className="column">
                <img
                  src={Aaron}
                  className="h-20 w-20 m-auto"
                />
                <p className="has-text-weight-bold is-size-4 person-title">Aaron Tsai</p>
                <p className="is-size-6">
                  <b>Co-founder</b> • Full-stack software engineer, ex-cancer researcher at UCSD published by Science, built & launched 15 products in 2018 with West Vesey<br /><br />
                </p>
              </div>
            </div>
          </div>
        </section>

          <section className="section">
            <div className="container clear-section-card">
              <div className="pricing-head has-text-centered is-centered has-text-black">
                <h2 className="title has-text-centered is-centered">We've helped companies like yours get hundreds of news features</h2>
                <p className="subtitle has-text-centered is-centered pricing-sub">Our PR campaigns have garnered millions of impressions from news websites, radio shows, and television segments all over the world from media outlets like The Washington Post, BBC, and VICE</p>
              </div>
              <div className="columns">
                <div className="column">
                  <img
                    src={ Rumblr }
                    className="case-study-image"
                  />
                </div>
                <div className="column is-para-case-study">
                  <div className="title is-size-4 para-title">
                    Rumblr was featured by hundreds of news outlets in just four days
                  </div>
                  <p className="is-size-5">We used Press Hunt's cold PR outreach strategy to get the attention of reporters, helping Rumblr get featured by hundreds of media outlets like The Independent, Fox & Friends, and Business Insider in only four days</p>
                  <a href="https://medium.com/the-mission/how-we-hacked-the-media-and-landed-six-figure-contracts-in-four-days-96ea4aca4eef" target="_blank">
                    <div className="button is-stripe-middle">READ THE CASE STUDY</div>
                  </a>
                </div>
              </div>
            </div>

            <div className="container clear-section-card">
              <div className="columns">
                  <div className="column is-hiw-card is-sample-card">
                    <a className="no-styling" href="https://www.independent.co.uk/life-style/gadgets-and-tech/news/rumblr-tinder-for-fighting-app-website-launch-date-beta-9-november-a6727561.html" target="_blank">
                      <div className="is-size-2 has-padding-bottom">
                        🥊
                      </div>
                      <div className="subtitle is-size-5 has-text-weight-bold">
                        Rumblr: The 'Tinder for fighting' website that allows users to arrange real-life brawls is set for launch
                      </div>
                      <p className="is-size-6 has-text-weight-normal" style={{opacity:'.5'}}>Featured by The Independent for Rumblr</p>
                    </a>
                  </div>
                <div className="column is-hiw-card is-sample-card">
                  <a className="no-styling" href="https://www.cltampa.com/music/music-news/article/20999358/radiate-the-tinder-of-coachella-also-works-at-sunset-music-festival-and-wanee" target="_blank">
                    <div className="is-size-2 has-padding-bottom">
                      💃
                    </div>
                    <div className="subtitle is-size-5 has-text-weight-bold">
                      The "Tinder for meeting people at Coachella" also works at Sunset Music Festival and Wanee
                    </div>
                    <p className="is-size-6 has-text-weight-normal" style={{opacity:'.5'}}>Featured by Creative Loafing: Tampa Bay for Radiate</p>
                  </a>
                </div>
                <div className="column is-hiw-card is-sample-card">
                  <a className="no-styling" href="https://mashable.com/2018/02/21/bitcoin-regret-club/#LRdfkjVTyOqN" target="_blank">
                    <div className="is-size-2 has-padding-bottom">
                      💸
                    </div>
                    <div className="subtitle is-size-5 has-text-weight-bold">
                      This might be the most depressing website ever made
                    </div>
                    <p className="is-size-6 has-text-weight-normal" style={{opacity:'.5'}}>Featured by Mashable for Bitcoin Regret Club</p>
                  </a>
                </div>
              </div>
              <div className="columns">
                <div className="column is-hiw-card is-sample-card">
                  <a className="no-styling" href="https://www.gonzagabulletin.com/news/article_b2319aba-2d46-11e8-9677-8333f5900a42.html" target="_blank">
                    <div className="is-size-2 has-padding-bottom">
                      📣
                    </div>
                    <div className="subtitle is-size-5 has-text-weight-bold">
                      March for Our Lives takes to the streets of Spokane this Saturday
                    </div>
                    <p className="is-size-6 has-text-weight-normal" style={{opacity:'.5'}}>Featured by The Gonzaga Bulletin for Betterplace</p>
                  </a>
                </div>
                <div className="column is-hiw-card is-sample-card">
                  <a className="no-styling" href="https://www.stuff.tv/hot-stuff/tablets-computers/pureshape-minimalist-mousepad-apples-magic-mouse-inspired-dieter-rams" target="_blank">
                    <div className="is-size-2 has-padding-bottom">
                      💻
                    </div>
                    <div className="subtitle is-size-5 has-text-weight-bold">
                      PureShape is a minimalist mousepad for Apple’s Magic Mouse, inspired by Dieter Rams
                    </div>
                    <p className="is-size-6 has-text-weight-normal" style={{opacity:'.5'}}>Featured by Stuff for PureShape</p>
                  </a>
                </div>
                <div className="column is-hiw-card is-sample-card">
                  <a className="no-styling" href="https://gameranx.com/features/id/141839/article/bacon-man-an-adventure-impressions-sizzling-porky-goodness/" target="_blank">
                    <div className="is-size-2 has-padding-bottom">
                      🐷
                    </div>
                    <div className="subtitle is-size-5 has-text-weight-bold">
                      Bacon Man: An Adventure Impressions—Sizzling Porky Goodness
                    </div>
                    <p className="is-size-6 has-text-weight-normal" style={{opacity:'.5'}}>Featured by Gameranx for Bacon Man: An Adventure</p>
                  </a>
                </div>
              </div>
              <div className="columns">
                <div className="column is-hiw-card is-sample-card">
                  <a className="no-styling" href="https://www.makeuseof.com/tag/gmail-message-ids-specific-emails/" target="_blank">
                    <div className="is-size-2 has-padding-bottom">
                      💌
                    </div>
                    <div className="subtitle is-size-5 has-text-weight-bold">
                      How to Bookmark Individual Emails Using Gmail Message IDs
                    </div>
                    <p className="is-size-6 has-text-weight-normal" style={{opacity:'.5'}}>Featured by MakeUseOf for Gmail Message ID Finder</p>
                  </a>
                </div>
                <div className="column is-hiw-card is-sample-card">
                  <a className="no-styling" href="http://www.iheartradio.ca/cjay92/trending/this-pool-sharing-site-is-genius-and-we-need-it-in-calgary-1.7383857" target="_blank">
                    <div className="is-size-2 has-padding-bottom">
                      🏊
                    </div>
                    <div className="subtitle is-size-5 has-text-weight-bold">
                      This Pool Sharing Site Is Genius and We Need It in Calgary
                    </div>
                    <p className="is-size-6 has-text-weight-normal" style={{opacity:'.5'}}>Featured by iHeartRadio for Swimply</p>
                  </a>
                </div>
                <div className="column is-hiw-card is-sample-card">
                  <a className="no-styling" href="https://observer.com/2016/02/how-rumblrs-marketing-agency-gamed-the-media-for-100k-in-business/" target="_blank">
                    <div className="is-size-2 has-padding-bottom">
                      🏴
                    </div>
                    <div className="subtitle is-size-5 has-text-weight-bold">
                      How Rumblr’s Marketing Agency Gamed the Media for $100k in Business
                    </div>
                    <p className="is-size-6 has-text-weight-normal" style={{opacity:'.5'}}>Featured by Observer for von Hughes</p>
                  </a>
                </div>
              </div>
              <div className="columns">
                <div className="column is-hiw-card is-sample-card" style={{backgroundColor:'transparent',boxShadow:'none'}}>
                  <a className="no-styling">
                    <div className="is-size-2 has-padding-bottom">

                    </div>
                    <div className="subtitle is-size-5 has-text-weight-bold">

                    </div>
                    <p className="is-size-6 has-text-weight-normal" style={{opacity:'.5'}}></p>
                  </a>
                </div>
                <div className="column is-hiw-card is-sample-card">
                  <a className="no-styling" href="https://cheddar.com/media/take-your-company-to-the-next-level-with-these-tech-trends/player?autoplay=false" target="_blank">
                    <div className="is-size-2 has-padding-bottom">
                      🤖
                    </div>
                    <div className="subtitle is-size-5 has-text-weight-bold">
                      Take Your Company to the Next Level With These Tech Trends
                    </div>
                    <p className="is-size-6 has-text-weight-normal" style={{opacity:'.5'}}>Featured by Cheddar TV for Press Hunt</p>
                  </a>
                </div>
                <div className="column is-hiw-card is-sample-card" style={{backgroundColor:'transparent',boxShadow:'none'}}>
                  <a className="no-styling">
                    <div className="is-size-2 has-padding-bottom">

                    </div>
                    <div className="subtitle is-size-5 has-text-weight-bold">

                    </div>
                    <p className="is-size-6 has-text-weight-normal" style={{opacity:'.5'}}></p>
                  </a>
                </div>
                </div>
              <div className="is-centered has-text-centered" style={{marginTop:'2em'}}>
                <a className="button is-stripe-hero" href="/pricing">Subscribe now</a>
              </div>

            </div>
          </section>
        <section className="section" id="FAQ">
          <div className="container clear-section-card-writing-samples">
            <div className="pricing-head has-text-centered is-centered has-text-black">
              <h2 className="title has-text-centered is-centered">FAQ</h2>
              <p className="subtitle has-text-centered is-centered pricing-sub">If our FAQ doesn't answer your questions, please reach out to us in our live chat in the bottom right.</p>
            </div>
            <div className="columns">
              <div className="column is-hiw-card">
                <div className="title is-size-5">
                  What kind of journalists do you have in this database?
                </div>
                <p className="is-size-6">Press Hunt has hundreds of thousands of journalists that cover every field you can imagine: sports journalists, fashion journalists, tech journalists, local new reporters, startups, science, crypto, art, theater, etc. Our journalists cover everywhere from the USA to China and Europe to Australia––we have journalists on every continent except Antarctica.</p>
              </div>
              <div className="column is-hiw-card">
                <div className="title is-size-5">
                  What do I do with the journalist emails?
                </div>
                <p className="is-size-6">You can email each journalist one-by-one; or you can add them to your own media list, then export their emails to CSV. You can then take your CSV and upload to mass emailing software like MixMax or Reply.io.</p>
              </div>
            </div>
            <div className="columns">
              <div className="column is-hiw-card">
                <div className="title is-size-5">
                  What is a media list?
                </div>
                <p className="is-size-6">A media list is simply a list of journalists created for a specific purpose. If you’re announcing a new product launch, you can put together a list of a few hundred journalists in your field that you think will be interested in covering your launch (based on the writing interests tags and other data we’ve provided for you). When you launch, you can send them all emails!</p>
              </div>
              <div className="column is-hiw-card">
                <div className="title is-size-5">
                  Why can’t I see journalist emails?
                </div>
                <p className="is-size-6">Our basic package doesn’t come with access to journalist emails––just their social media links. If you’re on a plan that includes emails, and you don’t see some, it is likely because we don’t have emails on record for that journalist or media outlet. This can be due to many reasons, from GDPR or privacy regulations to them not having their email publicly accessible.</p>
              </div>
            </div>
            <div className="columns">
              <div className="column is-hiw-card">
                <div className="title is-size-5">
                  Where do you get these contacts from?
                </div>
                <p className="is-size-6">We’ve manually built and labeled a lot of the data. We’ve also used some data science tricks to scan the web and overlay relevant data to output a complete journalist profile.</p>
              </div>
              <div className="column is-hiw-card">
                <div className="title is-size-5">
                  Are these contacts legit?
                </div>
                <p className="is-size-6">Yes. Through our testing we’ve found that 80% of these emails are valid and still make it to the intended recipient. 20% of the emails are outdated due to journalists changing jobs. We’re constantly filtering those out though, so if you find some, please let us know.</p>
              </div>
            </div>
            <div className="columns">
              <div className="column is-hiw-card">
                <div className="title is-size-5">
                  How often do you update this database?
                </div>
                <p className="is-size-6">We update this journalist database usually daily to include the most recent contact information and labels.</p>
              </div>
              <div className="column is-hiw-card">
                <div className="title is-size-5">
                  What do the journalist tags represent?
                </div>
                <p className="is-size-6">Tags for each journalist represent what they’re likely to want to write about, based on what they’ve written about before, outlets they’ve written for, and their tweets.</p>
              </div>
            </div>
            <div className="columns">
              <div className="column is-hiw-card">
                <div className="title is-size-5">
                  Are there duplicate journalists?
                </div>
                <p className="is-size-6">Some journalists work for multiple outlets or blogs and have multiple contacts for each. in this case, we do have multiple records for a few journalists. We’re working on reducing the amount of duplicates however, so if you see some, please let us know in our live chat in the bottom right.</p>
              </div>
              <div className="column is-hiw-card" style={{opacity:'0'}}>
                <div className="title is-size-5">

                </div>
                <p className="is-size-6"></p>
              </div>
            </div>
          </div>
        </section>

        <Footer />
      </div>
    );
  }
}

export default HomePage;
